import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import moment from "moment";
import { Button, Spin, DatePicker, Modal, Select } from "antd";

import FileSaver from "file-saver";

import { fetchExpensesDisctinctType, fetchExpensesDisctinctUsers } from "../../modules/presence/api/api";
import { isEmpty } from "lodash";

const Option = Select.Option;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";

const AccountingExports = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [rangeDate, setRangeDate] = useState([
    moment()
      .startOf("week")
      .add(-1, "week"),
    moment().endOf("week")
  ]);
  const [selectedUserEmail, setSelectedUserEmail] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [listUsers, setListUsers] = useState([]);
  const [listTypes, setListTypes] = useState([]);

  const exportNDFMealPackagesSummary = async () => {
    if (!selectedUserEmail && !selectedType && rangeDate[1].diff(rangeDate[0], "days") > 100) {
      Modal.error({
        title: "Erreur : période trop longue",
        content: `La période sélectionnée est trop longue. Veuillez sélectionner une période inférieure à 3 mois ou un collaborateur ou un type de note de frais.`
      });
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${baseapi}/expenses/export/expenses/`,
        {
          startDate: rangeDate[0].format("YYYY-MM-DD"),
          endDate: rangeDate[1].format("YYYY-MM-DD"),
          user_email: selectedUserEmail,
          expense_type: selectedType
        },
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: token
          }
        }
      );

      FileSaver.saveAs(
        new Blob([response.data], { type: "application/vnd.ms-excel" }),
        `Notes de frais du ${rangeDate[0].format("DD/MM/YYYY")} au ${rangeDate[1].format("DD/MM/YYYY")}.xlsx`
      );
    } catch (error) {
      const blob = new Blob([error.response.data], {
        type: error.response.headers["content-type"]
      });
      const reader = new FileReader();
      reader.onload = function() {
        Modal.error({
          title: "Erreur",
          content: this.result
        });
      };
      reader.readAsText(blob);
    } finally {
      setIsLoading(false);
    }
  };
  const onChangeFilterUser = emailSelected => {
    if (emailSelected) setSelectedUserEmail(emailSelected);
    else {
      setSelectedUserEmail(null);
    }
  };
  const onChangeFilterType = value => {
    if (value) setSelectedType(value);
    else setSelectedType(null);
  };
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30 }}>{`Page des exports pour la comptabilité`}</div>
        </div>
        <div style={{ margin: 20 }}></div>
        <div className="flex justify-around w-full">
          <DatePicker.RangePicker
            onChange={selectedRangeDate => {
              setRangeDate(selectedRangeDate);
            }}
            defaultValue={rangeDate}
            format={"DD/MM/YYYY"}
            placeholder={["Début", "Fin"]}
          />
          <Select
            allowClear={true}
            showSearch
            placeholder="Personne"
            style={{ width: 200 }}
            value={selectedUserEmail ? selectedUserEmail : []}
            onFocus={async () => {
              const response = await fetchExpensesDisctinctUsers({ hideNotInWorkforce: false }, token);
              setListUsers(response);
            }}
            onChange={email => onChangeFilterUser(email)}
          >
            {!isEmpty(listUsers) &&
              listUsers.sort().map(userEmail => (
                <Option key={userEmail} value={userEmail}>
                  {userEmail}
                </Option>
              ))}
          </Select>
          <Select
            allowClear={true}
            showSearch
            placeholder="Type"
            style={{ width: 200 }}
            value={selectedType ? selectedType : undefined}
            onFocus={async () => {
              const response = await fetchExpensesDisctinctType({}, token);

              setListTypes(response);
            }}
            onChange={item => onChangeFilterType(item)}
          >
            {!isEmpty(listTypes) &&
              listTypes.sort().map(expenseType => (
                <Option key={expenseType} value={expenseType}>
                  {expenseType}
                </Option>
              ))}
          </Select>
        </div>
      </HeaderContainer>
      {isLoading ? (
        <Spin></Spin>
      ) : (
        <Button
          type="primary"
          onClick={async () => {
            await exportNDFMealPackagesSummary();
          }}
        >
          {`Télécharger les notes de frais du ${rangeDate[0].format("DD/MM/YYYY")} au ${rangeDate[1].format(
            "DD/MM/YYYY"
          )}`}
        </Button>
      )}
    </Container>
  );
};

export default AccountingExports;



// WEBPACK FOOTER //
// src/pages/accounting/AccountingExports.js